import { render, staticRenderFns } from "./PanelTab.vue?vue&type=template&id=f6ff3cae&scoped=true&"
import script from "./PanelTab.vue?vue&type=script&lang=js&"
export * from "./PanelTab.vue?vue&type=script&lang=js&"
import style0 from "./PanelTab.vue?vue&type=style&index=0&id=f6ff3cae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ff3cae",
  null
  
)

export default component.exports